// Auth API client + localStorage session helpers.
// Session token stored in `pbo-auth-v1` as { session_token, user }.
// A single axios instance from lib/api.js is reused so we get the same base URL
// handling; here we attach the Authorization header via an interceptor.
import { api } from "./api";

const KEY = "pbo-auth-v1";

export function getAuth() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "null");
  } catch {
    return null;
  }
}

export function setAuth(v) {
  if (v) localStorage.setItem(KEY, JSON.stringify(v));
  else localStorage.removeItem(KEY);
  window.dispatchEvent(new CustomEvent("pbo-auth-change"));
}

export function clearAuth() {
  setAuth(null);
}

// Attach the bearer token to every request. Keeps flowing even after login.
api.interceptors.request.use((config) => {
  const auth = getAuth();
  if (auth?.session_token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${auth.session_token}`;
  }
  return config;
});

// Auto-signout on any 401 from the server. Safer than showing a stale UI.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && getAuth()) {
      clearAuth();
    }
    return Promise.reject(err);
  }
);

export const requestMagicLink = (email) =>
  api.post("/auth/request-magic-link", { email }).then((r) => r.data);

export const verifyMagicLink = (token) =>
  api.post("/auth/verify", { token }).then((r) => r.data);

export const verifyLoginCode = (email, code) =>
  api.post("/auth/verify-code", { email, code }).then((r) => r.data);

export const fetchMe = () => api.get("/auth/me").then((r) => r.data.user);

export const redeemSso = (token) =>
  api.post("/sso/redeem", { token }).then((r) => r.data);

export const logout = () =>
  api.post("/auth/logout").then((r) => r.data).catch(() => ({ ok: true }));

export const listMyContests = () =>
  api.get("/my-contests").then((r) => r.data.contests);

export const claimContestSeat = (code, memberId) =>
  api
    .post(`/contests/${code}/claim`, { member_id: memberId })
    .then((r) => r.data);
